class DewInquiryForm extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const service = this.querySelector('[data-inquiry-service]');
    const details = this.querySelector('[data-service-details]');
    if (!service || !details) return;
    const requested = new URL(window.location.href).searchParams.get('service');
    if ([...service.options].some(option => option.value === requested)) service.value = requested;
    const update = () => {
      const needsDetails = !['general', 'team'].includes(service.value);
      details.hidden = !needsDetails;
      details.disabled = !needsDetails;
    };
    service.addEventListener('change', update);
    update();
  }
}
if (!customElements.get('dew-inquiry-form')) customElements.define('dew-inquiry-form', DewInquiryForm);
